// navConfig.ts or similar
import { ROUTE_KEYS } from 'utils/constants';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';
import { ReactComponent as MetadataIcon } from 'assets/icons/metadata.svg';
import { LocationIcon } from 'cokitchen-icons';

export const getBrandDetailsNav = (search = '') => [
  {
    title: 'Shop details',
    link: `${ROUTE_KEYS.SHOP_FORM}/details${search}`,
    Icon: BrandDetailsIcon
  },
  {
    title: 'Shop images',
    link: `${ROUTE_KEYS.SHOP_FORM}/images${search}`,
    Icon: OpeningTimeIcon
  },
  {
    title: 'Shop opening time',
    link: `${ROUTE_KEYS.SHOP_FORM}/opening-time${search}`,
    Icon: OpeningTimeIcon
  },
  {
    title: 'Polygon',
    link: `${ROUTE_KEYS.SHOP_FORM}/polygon${search}`,
    Icon: LocationIcon
  },
  {
    title: 'Shop metadata',
    link: `${ROUTE_KEYS.SHOP_FORM}/metadata${search}`,
    Icon: MetadataIcon
  },
  {
    title: 'Fees',
    link: `${ROUTE_KEYS.SHOP_FORM}/fees${search}`,
    Icon: MetadataIcon
  },
  {
    title: 'Shop preview',
    link: `${ROUTE_KEYS.SHOP_FORM}/preview${search}`,
    Icon: MetadataIcon
  }
];
